

<div class="loader d-flex align-items-center justify-content-center" *ngIf="show">
  <div class="loader-container d-flex align-items-center">
    <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  </div>
</div>